import * as React from 'react';
import { alpha, styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import MuiToolbar from '@mui/material/Toolbar';
import { tabsClasses } from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import SideMenuMobile from './SideMenuMobile';
import MenuButton from './MenuButton';
import ColorModeIconDropdown from './ColorModeIconDropdown';

const Toolbar = styled(MuiToolbar)({
  width: '100%',
  padding: '12px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  justifyContent: 'center',
  gap: '12px',
  flexShrink: 0,
  [`& ${tabsClasses.flexContainer}`]: {
    gap: '8px',
    p: '8px',
    pb: 0,
  },
});

export default function AppNavbar() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        display: { xs: 'auto', md: 'none' },
        boxShadow: 0,
        bgcolor: 'transparent',
        backgroundImage: 'none',
        borderBottom: '1px solid',
        borderColor: 'divider',
        top: 'var(--template-frame-height, 0px)',
        backdropFilter: 'blur(18px)',
      }}
    >
      <Toolbar
        variant="regular"
        sx={(theme) => ({
          background: theme.vars
            ? `linear-gradient(180deg, rgba(${theme.vars.palette.background.paperChannel} / 0.74) 0%, rgba(${theme.vars.palette.background.defaultChannel} / 0.68) 100%)`
            : `linear-gradient(180deg, ${alpha(theme.palette.background.paper, 0.74)} 0%, ${alpha(theme.palette.background.default, 0.68)} 100%)`,
        })}
      >
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            flexGrow: 1,
            width: '100%',
            gap: 1,
          }}
        >
          <Stack
            direction="row"
            spacing={1}
            sx={{ justifyContent: 'center', mr: 'auto', alignItems: 'center' }}
          >
            <CustomIcon />
            <Box>
              <Typography variant="subtitle2" component="p" sx={{ color: 'text.secondary', lineHeight: 1.1 }}>
                EV Intelligence
              </Typography>
              <Typography variant="h6" component="h1" sx={{ color: 'text.primary', lineHeight: 1.2 }}>
                Dashboard
              </Typography>
            </Box>
            <Chip
              size="small"
              icon={<BoltRoundedIcon />}
              label="Live"
              sx={{
                borderRadius: 999,
                bgcolor: 'transparent',
                border: '1px solid',
                borderColor: 'divider',
              }}
            />
          </Stack>
          <ColorModeIconDropdown />
          <MenuButton aria-label="menu" onClick={toggleDrawer(true)}>
            <MenuRoundedIcon />
          </MenuButton>
          <SideMenuMobile open={open} toggleDrawer={toggleDrawer} />
        </Stack>
      </Toolbar>
    </AppBar>
  );
}

export function CustomIcon() {
  return (
    <Box
      component="span"
      sx={{
        width: '1.9rem',
        height: '1.9rem',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '6px',
        p: 0,
        flexShrink: 0,
        background: 'linear-gradient(145deg, rgba(68, 140, 255, 0.14), rgba(68, 140, 255, 0.04))',
        border: '1px solid rgba(130, 176, 255, 0.26)',
        boxShadow: '0 4px 10px rgba(26, 80, 189, 0.22)',
        alignSelf: 'center',
      }}
    >
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL || ''}/favicon.svg`}
        alt="EV Dashboard logo"
        sx={{
          width: 'auto',
          height: '74%',
          maxWidth: '74%',
          display: 'block',
          filter: 'drop-shadow(0 1px 1px rgba(0, 0, 0, 0.18))',
          transform: 'translateZ(0)',
        }}
      />
    </Box>
  );
}
